import { Play } from 'lucide-react';

export function VideoSidebar() {
  return (
    <div className="space-y-4">
      <div className="relative aspect-video overflow-hidden rounded-lg">
        <img
          src="https://images.unsplash.com/photo-1593697821028-7cc59cfd7399?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80"
          alt="Video Thumbnail"
          className="object-cover"
        />
        <div className="absolute inset-0 flex items-center justify-center bg-black/20">
          <Play className="h-12 w-12 text-white" />
        </div>
      </div>
      <div className="space-y-2">
        <h3 className="font-medium">Chapters</h3>
        <nav className="space-y-1">
          {['Introduction', 'Key Concepts', 'Examples', 'Summary'].map((chapter) => (
            <button
              key={chapter}
              className="w-full rounded-lg px-3 py-2 text-left text-sm hover:bg-gray-100"
            >
              {chapter}
            </button>
          ))}
        </nav>
      </div>
    </div>
  );
}